<script setup lang="ts">
import type { ApiKeyToken } from '@/types/apiKeys'

const props = defineProps<{
  open: boolean
  token: ApiKeyToken | null
  isSaving: boolean
}>()

const emit = defineEmits<{
  (e: 'update:open', value: boolean): void
  (e: 'rename', name: string): void
}>()

const { t } = useI18n()

const name = ref('')

watch(
  () => props.open,
  (isOpen) => {
    if (isOpen) name.value = props.token?.name ?? ''
  }
)

const canSubmit = computed(() => {
  const trimmed = name.value.trim()
  return trimmed.length > 0 && trimmed !== props.token?.name
})

const submit = () => {
  if (!canSubmit.value) return
  emit('rename', name.value.trim())
}
</script>

<template>
  <BaseModal
    :is-open="open"
    :heading-title="t('pages.settings.apiKeys.rename.title')"
    size="lg"
    :cancel="t('pages.settings.apiKeys.rename.cancel')"
    :link-text="t('pages.settings.apiKeys.rename.submit')"
    :is-processing="isSaving"
    :is-disabled="!canSubmit"
    @close="emit('update:open', false)"
    @click="submit"
  >
    <p class="mb-4 text-sm text-muted-foreground">{{ t('pages.settings.apiKeys.rename.description') }}</p>

    <div class="flex flex-col gap-2">
      <Label for="api-key-rename">{{ t('pages.settings.apiKeys.rename.nameLabel') }}</Label>
      <Input id="api-key-rename" v-model="name" maxlength="50" />
      <span class="font-mono text-xs text-muted-foreground">{{ token?.prefix }}</span>
    </div>
  </BaseModal>
</template>
